module.exports = __webpack_public_path__ + "img/chijieban5.471c474c.jpg";